import PropTypes from "prop-types";
import { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Experience, Skills } from "../../../constants";
import {
  FetchServicesOffered,
  OnServiceSubmit,
  OnAboutSubmit,
} from "../../../containers/venderFlow/profileSetup/queries";
import FeedbackFlow from "../../../containers/venderFlow/FeedBack";
import {
  addOtherSkills,
  deleteServiceRecord,
} from "../../../store/apiCalls/profilesetup";
import Form from "../../common/Form";
import Input from "../../commonComponents/Input";
import ToolTip from "../../common/Tooltip";
import Select from "../../commonComponents/Select";
import { ServicesOffered } from "../../../store/apiCalls/profilesetup";
import OtherServiceRequest from "./OtherServiceRequest";
import {
  isPublishable,
  ratesTooltip,
  supportedFileExtensions,
  isImage,
  removeDuplicates,
  statusObj,
  unPublishToolTip,
  panCardTooltip,
} from "../../../utils";
import { toast } from "react-toastify";
import Label from "../../commonComponents/Label";
import GraphicsAndDesign from "./GraphicsAndDesign";
import SampleWork from "./SampleShowModal";
import backIcon from "../../../assets/img/icons/arrow_left.svg";
import ServiceCongrats from "../../commonComponents/serviceCongratsModal";
import ImageDisplayModal from "../../commonComponents/ImageDisplayModal";
import UploadUrlModal from "../../commonComponents/uploadUrlModal";
import ProfileUploadModal from "../../commonComponents/ProfileUploadModal";
import { useState } from "react";
import UploadSampleWorks from "../../commonComponents/uploadSampleWorks";
import { checkUrl } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { SHOW_ERROR } from "../../../store/actions/profileActions";
import Button from "../../../components/common/Button";
import { type } from "@testing-library/user-event/dist/type";
import { async } from "@firebase/util";
import { SERVER_URL } from "../../../config";
import { UploadMedia } from "../../../store/apiCalls/profilesetup";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
};
const Services = (props) => {
  const {
    token,
    decodedId,
    servicesOffered,
    setServicesOffered,
    services,
    setServices,
    setSavedModal = () => {},
    servicesCount,
    setServicesCount,
    handleGoback,
    currentService,
    profileDetails = {},
    setCurrentService,
    setSamplesUpload,
    appendURL,
    DeleteMedia,
    DeletePancard,
    refetch,
  } = props;
  const PancardRef = useRef();
  const dispatch = useDispatch();
  const skillsData = useSelector((state) => state.Skills);
  const sucessHandler = (fetchedData) => {
    var clonedServiceCount = servicesCount.map((ser) => {
      const serviceData = fetchedData.data?.data?.find(
        (a) => a.serviceName === ser.serviceType
      );
      if (!ser.serviceOfferedId && serviceData) {
        ser.serviceOfferedId = serviceData._id;
      }
      return ser;
    });
    setServicesCount(clonedServiceCount);
    setServicesOffered(fetchedData?.data?.data);
  };

  const navigatePage = useNavigate();
  const [modalStat, setModalStat] = useState({
    showForm: false,
    showMsg: false,
  });
  const [fullScreen, setFullScreen] = useState({
    show: false,
    url: "",
    type: "image",
  });
  const [showFeedbackModal, setShowFeedbackModal] = useState(initialState);
  const [showSamples, setShowSamples] = useState({ show: false, samples: [] });
  const [pancard, setPancard] = useState("");
  const [eventType, setEventType] = useState(null);
  const [pancardFile, setPancardFile] = useState({});
  const [openPancardUpload, setopenPancardUpload] = useState(false);
  const [uploadSamples, setuploadSamples] = useState(false);
  const [openUrlModal, setOpenUrlModal] = useState(false);
  const [samples, setSamples] = useState({ images: [], url: [] });
  const [openViewSamplesModal, setOpenViewSamplesModal] = useState(false);
  const [url, setUrl] = useState("");
  const [urlError, setUrlError] = useState(false);
  const [noSamplesAvailable, setNoSamplesAvailable] = useState(false);
  const error = useSelector((state) => state.ProfileReducer?.typeError);
  const [otherSkill, setOtherSkill] = useState("");
  const [addedSkills, setAddedSkills] = useState("");
  // const [profilePublished, setProfilePublished] = useState(false);
  const fetchdata = async () => {
    const headers = { Authorization: `Bearer ${token}` };
    return ServicesOffered(headers);
  };

  const handleFullScreen = (e, url = "", type = "image") => {
    if (type === "image") {
      if (isImage(url)) {
        setFullScreen({ url: url, show: true, type });
      } else {
        window.open(url);
      }
    } else {
      setFullScreen({ url: url, show: true, type });
    }
  };

  const handleRedirect = (e) => {
    e.preventDefault();
    localStorage.clear();
    // dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
    window.navigation.navigate(SERVER_URL);
  };

  FetchServicesOffered(fetchdata, sucessHandler);
  const addAnotherServices = () => {
    let uuid = "service" + Math.random().toString(16).slice(2);
    const newService = servicesOffered.find(
      (a) => a.serviceName === "Copy Editing"
    );
    setServicesCount([
      ...servicesCount,
      {
        servicesuuid: uuid,
        serviceType: newService.serviceName,
        vendorId: decodedId,
        serviceOfferedId: newService._id,
        experience: "",
        skills: [],
        rates: [
          { levelNumber: 1, min: 100, max: 200, level: { min: "", max: "" } },
          { levelNumber: 2, min: 150, max: 300, level: { min: "", max: "" } },
        ],
        samples: [],
        pancardNumber: "",
        GSTNumber: "",
        uploadPancard: "",
      },
    ]);
  };

  const handleSelectChange = (value, service, type) => {
    const selectedValue = value;
    const cloneService = [...servicesCount];
    let updateServiceType = "";
    const serviceOfferedId = servicesOffered.find(
      (val) => val.serviceName === selectedValue
    );
    if (type === "serviceType") {
      if (
        selectedValue === "Graphics & Design" ||
        selectedValue === "Book Cover Design"
      ) {
        const levelNames = [
          {
            levelNumber: 1,
            min: 100,
            max: 200,
            level: {
              min: "",
              max: "",
            },
          },
          {
            levelNumber: 2,
            min: 150,
            max: 300,
            level: {
              min: "",
              max: "",
            },
          },
          {
            levelNumber: 3,
            min: 150,
            max: 300,
            level: {
              min: "",
              max: "",
            },
          },
        ];
        const newkeys = {
          rateChecked: false,
          useOfOriginalChecked: false,
          tableDesignChecked: false,
          formulaeChecked: false,
          useOfOriginal: levelNames,
          tableDesign: levelNames,
          formulae: levelNames,
        };
        updateServiceType = cloneService?.map((ser) => {
          return ser.servicesuuid === service.servicesuuid
            ? {
                ...ser,
                _id: ser._id,
                serviceId: ser._id,
                pancardNumber: ser.pancardNumber,
                servicesuuid: ser.servicesuuid,
                GSTNumber: ser.GSTNumber,
                skills: [],
                serviceOfferedId: serviceOfferedId?._id,
                serviceType: selectedValue,
                ...newkeys,
                rates:
                  selectedValue === "Graphics & Design" ||
                  selectedValue === "Book Cover Design"
                    ? [
                        // ...ser?.rates,
                        {
                          levelNumber: 1,
                          levelChecked: false,
                          level: { min: "", max: "" },
                        },
                        {
                          levelNumber: 2,
                          levelChecked: false,
                          level: { min: "", max: "" },
                        },
                        {
                          levelNumber: 3,
                          levelChecked: false,
                          level: { min: "", max: "" },
                        },
                      ]
                    : [...ser?.rates]?.splice(0, 2),
              }
            : ser;
        });
      } else if (
        ["Social Media", "Content Creator", "SEO"].indexOf(selectedValue) > -1
      ) {
        updateServiceType = cloneService?.map((ser) => {
          return ser.servicesuuid === service.servicesuuid
            ? {
                serviceId: ser._id,
                pancardNumber: ser.pancardNumber,
                _id: ser._id,
                GSTNumber: ser.GSTNumber,
                servicesuuid: ser.servicesuuid,
                serviceType: selectedValue,
                experience: String(ser.experience),
                serviceOfferedId: serviceOfferedId?._id,
                vendorId: decodedId,
                skills: [],
                uploadPancard: ser.uploadPancard,
              }
            : ser;
        });
      } else {
        updateServiceType = cloneService?.map((ser) => {
          return ser.servicesuuid === service.servicesuuid
            ? {
                pancardNumber: ser.pancardNumber,
                GSTNumber: ser.GSTNumber,
                serviceId: ser._id,
                _id: ser._id,
                uploadPancard: ser.uploadPancard,
                servicesuuid: ser.servicesuuid,
                serviceType: selectedValue,
                experience: String(ser.experience),
                serviceOfferedId: serviceOfferedId?._id,
                vendorId: decodedId,
                skills: [],
                rates: [
                  {
                    levelNumber: 1,
                    levelChecked: false,
                    level: { min: "", max: "" },
                  },
                  {
                    levelNumber: 2,
                    levelChecked: false,
                    level: { min: "", max: "" },
                  },
                ],
              }
            : ser;
        });
      }
    } else if (type === "skills") {
      updateServiceType = cloneService?.map((ser, ind) => {
        const objVals = servicesCount?.[ind]?.skills.map((v) => {
          return v?.name;
        });

        if (servicesCount?.[ind]?.skills?.name === "") {
          return ser;
        }
        if (objVals?.includes(selectedValue)) {
          return ser;
        }
        return ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [type]: [
                ...servicesCount?.[ind]?.skills,
                // { name: selectedValue },
                selectedValue,
              ],
            }
          : ser;
      });
    } else {
      updateServiceType = cloneService?.map((ser) => {
        return ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [type]: selectedValue,
            }
          : ser;
      });
    }

    if (type === "serviceType" && selectedValue === "Others") {
      setModalStat({
        showForm: true,
        showMsg: false,
        serviceOfferedId: service.serviceOfferedId,
        uuid: service.servicesuuid,
      });
    }
    setServicesCount(updateServiceType);
  };

  const handleChangeService = (e, service, type) => {
    const { value, checked} = e.target;
    const selectedValue = e.target.type === 'checkbox' ? checked : value;
    const cloneService = [...servicesCount];
    const serviceOfferedId = servicesOffered.find(
      (val) => val.serviceName === selectedValue
    );
    let updateServiceType = "";
    if (type === "serviceType") {
      if (
        selectedValue === "Graphics & Design" ||
        selectedValue === "Book Cover Design"
      ) {
        const levelNames = [
          {
            levelNumber: 1,
            min: 100,
            max: 200,
            level: {
              min: "",
              max: "",
            },
          },
          {
            levelNumber: 2,
            min: 150,
            max: 300,
            level: {
              min: "",
              max: "",
            },
          },
          {
            levelNumber: 3,
            min: 150,
            max: 300,
            level: {
              min: "",
              max: "",
            },
          },
        ];
        const newkeys = {
          rateChecked: false,
          useOfOriginalChecked: false,
          tableDesignChecked: false,
          formulaeChecked: false,
          useOfOriginal: levelNames,
          tableDesign: levelNames,
          formulae: levelNames,
        };
        updateServiceType = cloneService?.map((ser) => {
          return ser.servicesuuid === service.servicesuuid ||
            ser.serviceId === service.serviceId
            ? {
                ...ser,
                serviceId: ser._id,
                skills: [],
                _id: ser._id,
                serviceOfferedId: serviceOfferedId?._id,
                serviceType: selectedValue,
                ...newkeys,
                rates:
                  selectedValue === "Graphics & Design" ||
                  selectedValue === "Book Cover Design"
                    ? [
                        // ...ser?.rates,
                        {
                          levelNumber: 1,
                          levelChecked: false,
                          level: { min: "", max: "" },
                        },
                        {
                          levelNumber: 2,
                          levelChecked: false,
                          level: { min: "", max: "" },
                        },
                        {
                          levelNumber: 3,
                          levelChecked: false,
                          level: { min: "", max: "" },
                        },
                      ]
                    : [...ser?.rates]?.splice(0, 2),
              }
            : ser;
        });
      } else if (
        ["Social Media", "Content Creator", "SEO"].indexOf(selectedValue) > -1
      ) {
        updateServiceType = cloneService?.map((ser) => {
          return ser.servicesuuid === service.servicesuuid
            ? {
                serviceId: ser._id,
                pancardNumber: ser.pancardNumber,
                _id: ser._id,
                GSTNumber: ser.GSTNumber,
                servicesuuid: ser.servicesuuid,
                serviceType: selectedValue,
                experience: String(ser.experience),
                serviceOfferedId: serviceOfferedId?._id,
                vendorId: decodedId,
                skills: [],
                uploadPancard: ser.uploadPancard,
              }
            : ser;
        });
      } else {
        updateServiceType = cloneService?.map((ser) => {
          return ser.servicesuuid === service.servicesuuid
            ? {
                pancardNumber: ser.pancardNumber,
                GSTNumber: ser.GSTNumber,
                serviceId: ser._id,
                _id: ser._id,
                uploadPancard: ser.uploadPancard,
                servicesuuid: ser.servicesuuid,
                serviceType: selectedValue,
                experience: String(ser.experience),
                serviceOfferedId: serviceOfferedId?._id,
                vendorId: decodedId,
                skills: [],
                rates: [
                  {
                    levelNumber: 1,
                    levelChecked: false,
                    level: { min: "", max: "" },
                  },
                  {
                    levelNumber: 2,
                    levelChecked: false,
                    level: { min: "", max: "" },
                  },
                ],
              }
            : ser;
        });
      }
    } else if (type === "skills") {
      updateServiceType = cloneService?.map((ser, ind) => {
        const objVals = servicesCount?.[ind]?.skills.map((v) => {
          return v?.name;
        });

        if (servicesCount?.[ind]?.skills?.name === "") {
          return ser;
        }
        if (objVals?.includes(selectedValue)) {
          return ser;
        }
        return ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [type]: [
                ...servicesCount?.[ind]?.skills,
                // { name: selectedValue },
                selectedValue,
              ],
            }
          : ser;
      });
    } else {
      updateServiceType = cloneService?.map((ser) => {
        const selectedSer = ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [type]: selectedValue,
            }
          : ser;
        if(ser.servicesuuid === service.servicesuuid && type === 'not_have_any_samples' && selectedValue === true) {
          selectedSer.samples = []
        }
        return selectedSer
      });
    }

    if (type === "serviceType" && selectedValue === "Others") {
      setModalStat({
        showForm: true,
        showMsg: false,
        serviceOfferedId: service.serviceOfferedId,
        uuid: service.servicesuuid,
      });
    }

    setServicesCount(updateServiceType);
  };

  const handleChange = (e, type, skillValue, serviceObject, index) => {
    const { name, value } = e.target;
    if (type) {
      const cloneService = JSON.parse(JSON.stringify(servicesCount));
      const ChangeValue = cloneService?.map((ser) =>
        ser.servicesuuid === serviceObject.servicesuuid
          ? {
              ...ser,
              [type]: ser[type]?.map((skill, ind) =>
                ind === index ? { name: e.target.value } : skill
              ),
            }
          : ser
      );
      setServicesCount(ChangeValue);
    }

    return setServices({ ...services, [name]: value });
  };
  const handleRateChange = (e, service, ind, type) => {
    const { name, value } = e.target;
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    let Changerate = [];
    if (name === "levelChecked") {
      Changerate = cloneService?.map((ser) => {
        return ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [type]: ser[type]?.map((rate, RateIndex) =>
                RateIndex === ind
                  ? {
                      ...rate,
                      levelChecked: !rate.levelChecked,
                      level: { min: "", max: "" },
                    }
                  : rate
              ),
            }
          : ser;
      });
      // if(name==="")
    } else if (ind === "headerLevelChecked") {
      Changerate = cloneService?.map((ser) =>
        ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [name]: !service[name],
              [type]: ser[type]?.map((rate) => ({
                ...rate,
                levelChecked: false,
                level: { min: "", max: "" },
              })),
            }
          : ser
      );
    } else {
      Changerate = cloneService?.map((ser) =>
        ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              [type]: ser[type]?.map((rate, RateIndex) =>
                RateIndex === ind
                  ? { ...rate, level: { ...rate.level, [name]: value } }
                  : rate
              ),
            }
          : ser
      );
    }
    setServicesCount(Changerate);
  };
  const handleRemoveSkills = (_e, removeIndex, serviceIndex) => {
    var cloneService = [...servicesCount];
    const newClone = cloneService?.[serviceIndex]?.skills?.filter(
      (_val, index) => index !== removeIndex
    );

    cloneService[serviceIndex].skills = newClone;
    setServicesCount(cloneService);
  };

  const handleUploadClick = (e) => {
    e.target.children[0].click();
  };

  const SucessHandlerService = async (sucess) => {
    if (sucess.isSetupProfile) {
      const publishPayload = {
        headers: { Authorization: `Bearer ${token}` },
        vendoreId: decodedId,
      };
      await SubmitAboutTab(publishPayload);
    }
    const resp = await refetch();
    if (resp.isSuccess) {
      props.setProfileDetails(resp.data?.data?.data);
      if (localStorage.eventType === "PreviewProfile") {
        navigatePage("/profilePreview");
      } else if (localStorage.eventType === "PublishProfile") {
        if (checkForApprovedServices()) {
          setShowFeedbackModal({
            ...initialState,
            showFeedbackModal: !resp?.data?.data?.data?.feedbackDone,
            congratsPreview: resp?.data?.data?.data?.feedbackDone,
          });
        } else {
          setShowFeedbackModal({ ...initialState, unPublish: true });
        }
      } else if (localStorage.eventType === "Save") {
        setSavedModal(true);
      }
      localStorage.removeItem("eventType");
    }
  };

  const isServiceApproved = () => {
    let publishNow = false;
    profileDetails.serviceId?.map((ser) => {
      const status = ser?.requestForOtherServiceId?.status || ser.serviceStatus;
      publishNow = publishNow ? publishNow : status === "approved";
    });
    return publishNow;
  };

  const checkForApprovedServices = () => {
    const services = removeDuplicates(
      profileDetails?.serviceId?.map((a) => a.serviceOfferedId.serviceName)
    );
    return services.length > 1
      ? true
      : services[0] === "Others"
      ? isServiceApproved()
      : true;
  };

  const handleSubmit = (e, publishProfile = false) => {
    e.preventDefault();
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    let error = false;
    const ServiceBody = cloneService?.map((service, index) => {
      const validService = [
        'Copy Editing',
        'Graphics & Design',
        'Book Cover Design'
      ];
      if (index === 0 && !service.pancardNumber) {
        dispatch({
          type: SHOW_ERROR,
          payload: {
            message: "Please enter PAN card number",
            type: "PanCardNumber",
          },
        });
        error = true;
      } else if (index === 0 && !service.uploadPancard) {
        dispatch({
          type: SHOW_ERROR,
          payload: { message: "Please upload PAN card", type: "PanCardError" },
        });
        error = true;
      } else if (!service.experience) {
        dispatch({
          type: SHOW_ERROR,
          payload: {
            message: "Please select experience",
            type: `ExperienceError-${index}`,
          },
        });
        error = true;
      } else if (
        validService.includes(service.serviceType) &&
        !service.not_have_any_samples &&
        (!service.samples || service?.samples?.length === 0)
      ) {
        dispatch({
          type: SHOW_ERROR,
          payload: {
            message: "Please upload sample or enable checkbox if you don't have any samples to upload..",
            type: `uploadSampleError-${index}`,
          },
        });
        error = true;
      }

      // if (index >= 1 && !services.uploadPancard && !error) {
      //   error = false;
      // }

      service?.rates?.map((val) => {
        delete val.levelChecked;
        return val;
      });
      service?.tableDesign?.map((val) => {
        delete val.levelChecked;
        return val;
      });
      service?.useOfOriginal?.map((val) => {
        delete val.levelChecked;
        return val;
      });
      delete service.servicesuuid;
      delete service.serviceType;
      service.skills = service.skills
        ?.map((a) => (a._id ? a._id : a))
        .filter((a) => a);
      return service;
    });
    // service?.
    const headers = { Authorization: `Bearer ${token}` };
    const requiredParam = {
      body: { isSetupProfile: false, services: ServiceBody },
      headers,
    };
    if (!error) {
      dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
      localStorage.setItem("eventType", e.nativeEvent?.submitter?.id);
      SubmitServiceTab(requiredParam);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const { mutate: SubmitServiceTab } = OnServiceSubmit(SucessHandlerService);
  const { mutate: SubmitAboutTab } = OnAboutSubmit(SucessHandlerService);

  const serviceRemoveURL = (e, sample) => {
    const clonedServ = JSON.parse(JSON.stringify(servicesCount));
    const updateSev = clonedServ.find((a) =>
      a.samples?.find((b) => b._id === sample._id)
    );

    if (updateSev) {
      const filteredRec = updateSev?.samples?.filter((b) => {
        return (
          (sample._id ? b._id !== sample._id : true) &&
          (sample.url ? b.url !== sample.url : true) &&
          (sample.uploadSamples
            ? b.uploadSamples !== sample.uploadSamples
            : true)
        );
      });
      updateSev.samples = filteredRec;
    }
    setServicesCount(clonedServ);
    setShowSamples(false);
  };

  const removeURL = (image, service) => {
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    const cloneCurrentService = JSON.parse(JSON.stringify(service));
    if (image._id) {
      const requiredParam = {
        headers: { Authorization: `Bearer ${token}` },

        serviceId: service?.serviceId,
        servicesuuid: service?.servicesuuid,
        body: { url: image.url },
      };
      DeleteMedia(requiredParam);
    } else {
      const deleteURl = cloneService?.map((ser) => {
        const selectedSer = ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              samples: ser.samples.filter((item) => item.url !== image.url),
            }
          : ser
          selectedSer.not_have_any_samples = selectedSer.samples.length < 1 ? true : false;
        return selectedSer
      }
      );
      if (cloneCurrentService?.samples) {
        const updateCurrentservice = cloneCurrentService?.samples?.filter(
          (item) => item.url !== image.url
        );
        setCurrentService(updateCurrentservice);
      }

      setServicesCount(deleteURl);
    }
  };
  const handleClosePancardUpload = () => {
    setopenPancardUpload(false);
    setPancard("");
    setPancardFile({});
    dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
  };

  const handleFileChange = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    const fileExtension = file.type?.split("/")[1]?.toString();
    if (
      supportedFileExtensions.indexOf(fileExtension?.toLowerCase() > -1) &&
      file.size < 50000000
    ) {
      setPancardFile(file);
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setPancard(reader.result);
      };
      dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
    } else {
      dispatch({
        type: SHOW_ERROR,
        payload: {
          message: "Formate not supported or image Size is greater then 50 mb",
          type: "PanCardSizeError",
        },
      });
    }
  };

  const handleFileUploadClick = (e) => {
    PancardRef.current.click();
  };
  const handleOpenPancardModal = (service) => {
    setCurrentService(service);
    setPancard("");
    setSamplesUpload(false);
    setopenPancardUpload(true);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("file", pancardFile);
    dispatch({ type: "SET_LOADER_STATUS", loading: true });
    const uploadResp = await UploadMedia(formData);
    dispatch({ type: "SET_LOADER_STATUS", loading: false });
    if (uploadResp.status === 200) {
      const clonedServices = JSON.parse(JSON.stringify(servicesCount));
      const serviceActive = clonedServices.find(
        (a) => a.servicesuuid === currentService.servicesuuid
      );
      if (serviceActive) {
        serviceActive.not_have_any_samples = false;
        serviceActive.uploadPancard = uploadResp?.data?.url || "";
      }
      setServicesCount(clonedServices);
    }
    setopenPancardUpload(false);
    setPancardFile("");
  };

  const handleuploadSamplesClose = () => {
    setuploadSamples(false);
    setUrlError(false);
    setUrl("");
  };

  const handleOpenSampleModal = (service) => {
    setuploadSamples(true);
    setCurrentService(service);
  };

  const handleAddUrlModal = () => {
    setuploadSamples(false);
    setOpenUrlModal(true);
    setUrlError(false);
  };
  const handleurlModalClose = () => {
    setOpenUrlModal(false);
    setUrlError(false);
    setSamplesUpload(false);
    setUrl("");
  };
  const handleGOPreviousModal = () => {
    setOpenUrlModal(false);
    setuploadSamples(true);
    setUrlError(false);
    setUrl("");
  };

  const clearSamples = (service) => {
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    const cloneCurrentService = JSON.parse(JSON.stringify(service));

    const updateSamples = cloneService?.map((ser) =>
    ser.servicesuuid === service.servicesuuid
    ? {
      ...ser,
      samples: [],
      not_have_any_samples: !ser?.not_have_any_samples,
    }
    : {
      ...ser,
      not_have_any_samples: false,
    }
    );
    setServicesCount(updateSamples);
  };

  const handleuploadUrl = (e, service) => {
    e.preventDefault();
    const checkURL = checkUrl(url);
    if (!checkURL) {
      setUrlError(true);
      setOpenUrlModal(false);
    } else {
      const clonedServicesCount = JSON.parse(JSON.stringify(servicesCount));
      const activeService = clonedServicesCount.find(
        (a) => a.servicesuuid === currentService.servicesuuid
      );
      if (activeService) {
        activeService.not_have_any_samples = false;
        activeService.samples = activeService.samples ? activeService.samples : [];
        activeService.samples = [
          ...activeService.samples,
          { uploadSamples: "", url: url },
        ];
        activeService.not_have_any_samples = false;
        setServicesCount(clonedServicesCount);
        setUrl("");
        setuploadSamples(false);
        setOpenUrlModal(false);
        setUrlError(false);
      }
    }
  };

  const handleShowSamples = (e, samples = []) => {
    e.preventDefault();
    setShowSamples({ show: true, samples: samples });
  };

  const handleCloseSampleWork = (e) => {
    e.preventDefault();
    setShowSamples({ show: false, samples: [] });
  };

  const handleEnlarge = (service) => {
    setCurrentService(service);
    setOpenViewSamplesModal(true);
  };

  const handleImageDisplayClose = () => {
    setOpenViewSamplesModal(false);
    dispatch({ type: SHOW_ERROR, payload: { message: "", type: "" } });
  };
  const handleDeleteMedia = (image, service) => {
    // if()
    // new code
    const cloneService = JSON.parse(JSON.stringify(servicesCount));
    const cloneCurrentService = JSON.parse(JSON.stringify(service));
    if (image._id) {
      const requiredParam = {
        headers: { Authorization: `Bearer ${token}` },

        serviceId: service?.serviceId,
        servicesuuid: service?.servicesuuid,
        body: { uploadSamples: image.uploadSamples },
      };
      //  setCurrentService(service)
      DeleteMedia(requiredParam);
    } else {
      const deletemedia = cloneService?.map((ser) => {
        const selectedSer = ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              samples: ser.samples.filter(
                (item) => item.uploadSamples !== image.uploadSamples
              ),
            }
          : ser

        selectedSer.not_have_any_samples = selectedSer.samples.length < 1 ? true : false;
        return selectedSer
      }
      );
      if (cloneCurrentService?.samples) {
        const updateCurrentservice = cloneCurrentService?.samples?.filter(
          (item) => item.uploadSamples !== image.uploadSamples
        );
        setCurrentService(updateCurrentservice);
      }

      setServicesCount(deletemedia);
    }

    //vew code
  };
  const handleDeltePan = (_pan, service) => {
    if (service.serviceId) {
      const requiredParam = {
        headers: { Authorization: `Bearer ${token}` },
        serviceId: service?.serviceId,
        servicesuuid: service?.servicesuuid,
      };
      DeletePancard(requiredParam);
    } else {
      const cloneService = JSON.parse(JSON.stringify(servicesCount));

      const updateSamples = cloneService?.map((ser) =>
        ser.servicesuuid === service.servicesuuid
          ? {
              ...ser,
              uploadPancard: "",
            }
          : {
              ...ser,
              not_have_any_samples: false,
            }
      );
      setServicesCount(updateSamples);
    }
  };
  const renderUploadedSamples = (service) => {
    if (service?.samples?.length > 0) {
      if (service?.samples[0]?.uploadSamples) {
        return (
          <>
            <div class="imgWrap-opt">
              <a
                onClick={() => handleDeleteMedia(service?.samples[0], service)}
              >
                <b class="icon-bin"></b>
              </a>
              <a>
                <b
                  class="icon-fullscreen"
                  onClick={(e) =>
                    handleFullScreen(e, service?.samples[0]?.uploadSamples)
                  }
                ></b>
              </a>
            </div>
            <img src={service?.samples[0]?.uploadSamples} alt="#" />
          </>
        );
      }
      return (
        <>
          <div class="urlWrap">
            <b class="icon-link urlWrap-icon"></b>
            <p class="urlWrap-url">{service?.samples[0]?.url}</p>
            <div class="urlWrap-opt">
              <a onClick={() => removeURL(service?.samples[0], service)}>
                <b class="icon-bin"></b>
              </a>
              <a
                onClick={(e) =>
                  handleFullScreen(e, service?.samples[0]?.url, "url")
                }
              >
                <b class="icon-fullscreen"></b>
              </a>
            </div>
          </div>
        </>
      );
    }
    return (
      <a
        className="w-auto"
        onClick={() => handleOpenSampleModal(service)}
        class="uploadBtn w-auto"
      >
        <b class="icon-upload"></b>Upload
      </a>
    );
  };

  const render = (service, index) => {
    switch (service.serviceType) {
      case "Copy Editing":
        return (
          <div class="fieldSet">
            <div class="anotherService pt-2">
              <div class="anotherService-col">
                <h2 class="mb-0 titleText">Rates</h2>
                <ul class="rateList px-5 ps-0">
                  {service?.rates?.map((rate, ind) => {
                    return (
                      <li key={ind}>
                        <div class="rateLevel pt-0">
                          <div class=" d-inline-flex rateCheck">
                            {" "}
                            <label class="styledCheck">
                              <input
                                type="checkbox"
                                name="levelChecked"
                                checked={rate?.levelChecked}
                                onChange={(e) =>
                                  handleRateChange(e, service, ind, "rates")
                                }
                              />
                              <span>
                                Level
                                {" " + rate.levelNumber}
                              </span>
                            </label>
                            <ToolTip
                              show={true}
                              placement="top"
                              toolTipMessage={ratesTooltip(rate.levelNumber)}
                            >
                              <a class="infoMark">i</a>
                            </ToolTip>
                          </div>
                          <div class="minMax">
                            <div class="minMax-col">
                              <Label labelText="₹ Minimum" />
                              <Input
                                type="number"
                                handleChange={(e) =>
                                  handleRateChange(e, service, ind, "rates")
                                }
                                name="min"
                                value={rate?.level?.min}
                                min={rate.levelNumber > 1 ? 150 : 100}
                                max={rate.levelNumber > 1 ? 300 : 200}
                                pattern="^(\+?\d+|-?0+){3}$"
                                required={rate?.levelChecked || true}
                                readOnly={!rate?.levelChecked}
                              />
                            </div>
                            <div class="minMax-dash">-</div>
                            <div class="minMax-col">
                              <Label labelText="₹ Maximum" />
                              <Input
                                type="number"
                                name={"max"}
                                min={
                                  rate?.level?.min ||
                                  (rate.levelNumber > 1 ? 150 : 100)
                                }
                                max={rate.levelNumber > 1 ? 300 : 200}
                                value={rate?.level?.max}
                                handleChange={(e) =>
                                  handleRateChange(e, service, ind, "rates")
                                }
                                required={rate?.levelChecked || true}
                                readOnly={!rate?.levelChecked}
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
                <small>
                  Copy editing beyond Level 2 is currently outside our preview
                  and should be negotiated directly with the customer
                </small>
                <div className="sevahaat-text">
                  <span>*Seva Haat Service Fee Applicable</span>
                  <p>
                    Since this task is performed on our platform,
                    <br />a service fee of 20% shall be applicable.
                  </p>
                </div>
              </div>
              <div class="anotherService-col">
                <h2 class="mb-1 titleText">
                  Upload Sample Work{" "}
                  <small className="labelBadge">Mandatory</small>
                  <a
                    onClick={() => handleOpenSampleModal(service)}
                    class="uploadLink ms-4"
                  >
                    <b class="icon-upload"></b>Upload
                  </a>
                </h2>
                <p class="sampleText">Show your best work to the customers</p>
                <small class="sampleNote">You can upload upto 6 samples</small>
                <p class="sampleCond">
                  <span>
                    Accepted Formats: <b>PDF/PNG/JPG/Tiff</b>
                  </span>
                  <span>
                    Required Size: <b>50MB</b>
                  </span>
                </p>

                <div class="sampleUpload mb-3">
                  <div class="sampleUpload-file">
                    <div class="imgWrap">{renderUploadedSamples(service)}</div>
                  </div>
                  <div class="sampleUpload-more">
                    {service?.samples?.length - 1 > 0 && (
                      <a
                      href="#"
                      onClick={(e) => handleShowSamples(e, service.samples)}
                      >
                        +{service?.samples?.length - 1}
                      </a>
                    )}
                    <small
                      onClick={(e) =>
                        service.samples.length > 0
                        ? handleShowSamples(e, service.samples)
                        : ""
                      }
                      >
                      <span>
                        <b className="icon-fullscreen" />
                      </span>
                      Click this button to enlarge the image
                    </small>
                  </div>
                </div>
                <label class="styledCheck">
                  <input
                    type="checkbox"
                    onChange={(e) => {clearSamples(service); handleChangeService(e, service, "not_have_any_samples")}}
                    checked={service?.not_have_any_samples}
                    />
                  <span>I don’t have any samples to upload</span>
                </label>
                <small class="sampleNote mt-1">
                  Showcasing your work increases your chances of customers
                  wanting to work with you
                </small>
                  {error?.type === `uploadSampleError-${index}` && (
                    <div ref={ref => ref?.scrollIntoView()} className="label-error">{error?.message}</div>
                  )}
              </div>
            </div>
          </div>
        );
      case "Graphics & Design":
      case "Book Cover Design":
        return (
          <>
            <GraphicsAndDesign
              index={index}
              handleChangeService={handleChangeService}
              service={service}
              setNoSamplesAvailable={setNoSamplesAvailable}
              clearSamples={clearSamples}
              handleChange={handleRateChange}
              setuploadSamples={setuploadSamples}
              handleEnlarge={setFullScreen}
              handleShowSamples={handleShowSamples}
              handleOpenSampleModal={handleOpenSampleModal}
              removeURL={removeURL}
              handleDeleteMedia={handleDeleteMedia}
            />
          </>
        );
      default:
        break;
    }
  };

  const handleFeedbackModalStat = (data, refetchData = false) => {
    if (refetchData) {
      fetchdata();
      props.setProfileDetails({ feedbackDone: refetchData, ...profileDetails });
    }
    setShowFeedbackModal(data);
  };

  const deleteService = async (recordId = "") => {
    const headers = { Authorization: `Bearer ${token}` };
    dispatch({ type: "SET_LOADER_STATUS", loading: true });
    const deleteResp = await deleteServiceRecord({
      headers,
      data: { serviceId: recordId },
    });
    dispatch({ type: "SET_LOADER_STATUS", loading: false });
    if (deleteResp.data.success) {
      updateServiceCount(recordId);
    } else {
      toast.error(deleteResp.data.message);
    }
  };

  const removeExpertise = async (selectedService) => {
    if (selectedService._id) {
      deleteService(selectedService._id);
    } else {
      updateServiceCount(selectedService.servicesuuid);
    }
    dispatch({
      type: SHOW_ERROR,
      payload: { message: "Please upload PAN card", type: "PanCardError" },
    });
  };

  const updateServiceCount = (id = "") => {
    let clonedServices = JSON.parse(JSON.stringify(servicesCount));
    clonedServices = clonedServices.filter((a) => a.servicesuuid != id);
    setServicesCount(clonedServices);
  };

  const addOtherSkill = async (service = "", skillId = "") => {
    const headers = { Authorization: `Bearer ${token}` };
    const response = await addOtherSkills({ skillname: otherSkill }, headers);
    if (response?.status === 200) {
      setAddedSkills(response?.data?.data);
      const clonedServices = JSON.parse(JSON.stringify(servicesCount));
      const updatedService = clonedServices.find(
        (a) => a.servicesuuid === service.servicesuuid
      );
      if (updatedService) {
        const skillObj = response?.data?.data || {};
        updatedService.skills = updatedService.skills.filter(
          (a) => a._id !== skillId.skill_id && a !== skillId.skill_id
        );
        updatedService.skills = [...updatedService.skills, skillObj];
      }
      setServicesCount(clonedServices);
      setOtherSkill("");
    } else {
      return toast.error(response.data.message || "Please try again");
    }
  };

  const updateServicesData = (id = "", serviceId = "", serviceText = "") => {
    const clonedServices = JSON.parse(JSON.stringify(servicesCount));
    const updatedService = clonedServices.find(
      (a) => a.servicesuuid === serviceId
    );
    if (updatedService) {
      updatedService.requestForOtherServiceId = id;
      updatedService.serviceText = serviceText;
      updatedService.serviceStatus = "pending";
    }
    setServicesCount(clonedServices);
  };

  return (
    <>
      <FeedbackFlow
        handleModalClose={handleFeedbackModalStat}
        modalStat={showFeedbackModal}
        profileData={profileDetails}
        code={profileDetails.promoCode}
        // onProfilePublish={() => setProfilePublished(true)}
      />

      <Form onSubmit={(e) => handleSubmit(e)} id="services">
        {servicesCount?.map((service, ind) => {
          const currentSer = skillsData.find(
            (a) => a.serviceOfferedId === service.serviceOfferedId
          );
          const skillOptions = currentSer ? currentSer.skillId : [];
          return (
            <div class="boxCover" key={service.servicesuuid}>
              <div class="boxTitle-expertise">
                <h1 class="titleText">Describe your expertise. Stand out</h1>
                {ind >= 1 && (
                  <>
                    <div
                      className="remove"
                      onClick={() => removeExpertise(service)}
                    >
                      Remove This Service
                    </div>
                  </>
                )}
              </div>
              <p className="expertise-para">
                It’s the first thing clients will see so make it count
              </p>

              <div class="fieldSet border-0 pt-2">
                <ul>
                  <li>
                    <div class="fieldWrap mb-3">
                      <Label className="labelForm">
                        Service Offered
                        <small className="labelBadge">Mandatory</small>
                      </Label>

                      <Select
                        placeholder="Select Service Offered"
                        className="fieldForm"
                        options={servicesOffered?.map((val) => val.serviceName)}
                        name="serviceOffered"
                        handleChange={(e) =>
                          handleSelectChange(e, service, "serviceType")
                        }
                        // required={true}
                        selectedValue={service?.serviceType}
                        // disabled={service?.serviceId}
                      />
                    </div>
                    {service.serviceType === "Others" &&
                      service.serviceText && (
                        <div className="form-group mb-4 other-text position-relative verify-link">
                          <div>
                            <Input
                              // type="url"
                              className="form-control active-input with_icon"
                              placeholder="URL of university/company/others"
                              name="URL"
                              label="URL of university/company/others"
                              value={service.serviceText}
                              postTextClass={
                                service.serviceStatus !== "approved"
                                  ? "Edit"
                                  : null
                              }
                              onIconClick={() =>
                                setModalStat({
                                  service,
                                  value: service.serviceText,
                                  showForm: true,
                                  showMsg: false,
                                  serviceOfferedId: service.serviceOfferedId,
                                  uuid: service.servicesuuid,
                                })
                              }
                              readOnly={true}
                            />
                            <div
                              className="input_post link"
                              dangerouslySetInnerHTML={{
                                __html: `<small class="labelBadge">${
                                  statusObj[service.serviceStatus]
                                }</small>`,
                              }}
                            />

                            {statusObj[service.serviceStatus] === "approved" ? (
                              <ToolTip
                                placement="top"
                                toolTipMessage="You can't edit this field now."
                              >
                                <a
                                  class="infoMark"
                                  style={{
                                    position: "absolute",
                                    top: "9px",
                                    right: "-25px",
                                  }}
                                >
                                  i
                                </a>
                              </ToolTip>
                            ) : null}
                          </div>
                        </div>
                      )}
                  </li>
                  <li>
                    <div
                      className={
                        error?.type === `ExperienceError-${ind}`
                          ? "fieldWrap error mb-3"
                          : ""
                      }
                    >
                      <Label className="labelForm">
                        Work Experience
                        <small className="labelBadge">Mandatory</small>
                      </Label>
                      <Select
                        className="fieldForm"
                        options={Experience}
                        name="experience"
                        handleChange={(e) =>
                          handleSelectChange(e, service, "experience")
                        }
                        // required={true}
                        selectedValue={service?.experience}
                      />
                      {error?.type === `ExperienceError-${ind}` && (
                        <div ref={ref => ref?.scrollIntoView()} className="label-error">{error?.message}</div>
                      )}
                    </div>
                  </li>
                  <li>
                    {ind >= 1 ? null : (
                      <div class="fieldWrap mb-3">
                        <Label className="labelForm">
                          PAN Card Number{" "}
                          <small class="labelBadge">Mandatory</small>
                        </Label>
                        <Input
                          className={
                            error?.type === "PanCardNumber"
                              ? "fieldForm-border"
                              : "fieldForm"
                          }
                          type="text"
                          name="pancardNumber"
                          value={service?.pancardNumber}
                          handleChange={(e) =>
                            handleChangeService(e, service, "pancardNumber")
                          }
                          // required
                        />
                        {error?.type === "PanCardNumber" && (
                          <div className="label-error">{error?.message}</div>
                        )}
                      </div>
                    )}
                  </li>
                  <li>
                    {ind >= 1 ? null : (
                      <div class="fieldWrap mb-3">
                        <Label className="labelForm">
                          GST Number <small class="otherBadge">Optional</small>
                        </Label>
                        <Input
                          className={"fieldForm"}
                          type="text"
                          name="GSTNumber"
                          value={service?.GSTNumber}
                          handleChange={(e) =>
                            handleChangeService(e, service, "GSTNumber")
                          }
                        />
                      </div>
                    )}
                  </li>
                  <li>
                    {ind >= 1 ? null : (
                      <div class="fieldWrap mb-3">
                        <Label className="labelForm">
                          PAN Card Image
                          <ToolTip
                            placement="top"
                            toolTipMessage={panCardTooltip()}
                          >
                            <a class="infoMark">i</a>
                          </ToolTip>
                          <small class="labelBadge">Mandatory</small>
                        </Label>
                        {service?.uploadPancard ? (
                          <div class="imageUpload-row mt-3">
                            <div class="imageUpload-file">
                              <div class="imgWrap">
                                <div class="imgWrap-opt">
                                  <a
                                    onClick={() =>
                                      handleDeltePan(
                                        service?.uploadPancard,
                                        service
                                      )
                                    }
                                  >
                                    <b class="icon-bin"></b>
                                  </a>
                                </div>
                                <img src={service?.uploadPancard} alt="#" />
                              </div>
                            </div>
                            <a
                              onClick={() => handleOpenPancardModal(service)}
                              class="imageUpload-updated"
                            >
                              Update
                            </a>
                          </div>
                        ) : (
                          <div>
                            <a
                              onClick={() => handleOpenPancardModal(service)}
                              class="uploadBtn"
                            >
                              <b class="icon-upload"></b>Upload
                            </a>
                            {error?.type === "PanCardError" && (
                              <div className="label-error">
                                {error?.message}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </li>
                  {service.serviceType !== "Others" && (
                    <li className="multiselect-skills pb-2">
                      <div class="fieldWrap mb-3">
                        <Label className="labelForm">
                          Skills <span>(Choose multiple)</span>
                        </Label>
                        <Select
                          placeholder="Select"
                          className="fieldForm"
                          options={skillOptions}
                          name="skills"
                          serviceName={service.serviceType}
                          handleChange={(e) =>
                            handleSelectChange(e, service, "skills")
                          }
                          selectedValue={
                            service?.skills?.[0]?._id
                              ? service?.skills?.[0]?._id
                              : ""
                          }
                        />
                      </div>

                      <div class="tagWrap mt-3">
                        {service?.skills?.map((v, i) => {
                          let selectedSkills = v._id ? v._id : v;
                          const selectedSkillId =
                            skillOptions.find(
                              (a) => a.skill_id === selectedSkills
                            ) || (v._id ? v : {});
                          if (
                            v &&
                            selectedSkillId &&
                            selectedSkillId?.skillName !== "Others"
                          ) {
                            return (
                              <div class="tagBox" key={selectedSkillId._id}>
                                {(selectedSkillId.skillName ||
                                  selectedSkillId.skillname) + " "}
                                <a
                                  onClick={(e) => handleRemoveSkills(e, i, ind)}
                                >
                                  <b class="icon-cross"></b>
                                </a>
                              </div>
                            );
                          } else if (selectedSkillId?.skillName == "Others") {
                            return (
                              <div class="tagBox" key={selectedSkillId._id}>
                                <Input
                                  className="fieldForm"
                                  type="text"
                                  placeholder="Type in here"
                                  name="otherSkill"
                                  value={otherSkill}
                                  handleChange={(e) =>
                                    setOtherSkill(e.target.value)
                                  }
                                />
                                <div
                                  className="button"
                                  onClick={() =>
                                    addOtherSkill(service, selectedSkillId)
                                  }
                                >
                                  Add
                                </div>
                                <a
                                  onClick={(e) => handleRemoveSkills(e, i, ind)}
                                >
                                  <b class="icon-cross"></b>
                                </a>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </li>
                  )}
                </ul>
              </div>
              {render(service, ind)}
            </div>
          );
        })}

        {/* {!profilePublished ? ( */}
          <div class="text-center boxFooter">
            <a onClick={() => handleGoback()} class="goBack">
              Back
              <b>
                <img src={backIcon} alt="#" />
              </b>
            </a>

            <button type="button" onClick={() => addAnotherServices()} class="button">
              + Add Another Service
            </button>
            <button style={{ marginRight: '1.5rem' }} id="Save" class="button" type="submit" form="services">
              SAVE
            </button>
            <Button
              className="button button-primary"
              type="submit"
              onClick={(e) => handleSubmit(e, true)}
              // disabled={!isPublishable(profileDetails)}
              placement="auto"
              // toolTipMessage={
              //   isPublishable(profileDetails) ? "" : unPublishToolTip
              // }
              id="PublishProfile"
              title="Publish Profile"
            />
          </div>
        {/* ) : ( */}
          {/* <div className="text-center" style={{ margin: "20px 0" }}>
            <Link
              to="/vendordashboard"
              onClick={(e) => handleRedirect(e)}
              className="link text-decoration-none f-700"
            >
              HOME
            </Link>
          </div> */}
        {/* )} */}
        <ImageDisplayModal
          show={openViewSamplesModal}
          close={handleImageDisplayClose}
          currentService={currentService}
          handleDeleteMedia={handleDeleteMedia}
          removeURL={removeURL}
        />

        <OtherServiceRequest
          defaultVal={modalStat.value}
          updateServices={updateServicesData}
          setModalStat={setModalStat}
          modalStat={modalStat}
        />
        <Modal
          id="fullScreen-modal"
          dialogClassName="modal-dialog-centered modal-bg modal-xl"
          show={fullScreen.show}
        >
          <div>
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                onClick={(e) => setFullScreen({ show: false, url: "" })}
              />
            </div>

            <div className="modal-body">
              {fullScreen.type === "url" ? (
                <p>{fullScreen.url}</p>
              ) : (
                <img src={fullScreen.url} alt="image" />
              )}
            </div>
          </div>
          <div className="modal-body">
            {fullScreen.type === "url" ? (
              <p>{fullScreen.url}</p>
            ) : (
              <img src={fullScreen.url} alt="image" />
            )}
          </div>
          {/* </div> */}
        </Modal>

        <ProfileUploadModal
          handleClose={handleClosePancardUpload}
          modalHeading="Upload PAN Card"
          show={openPancardUpload}
        >
          <div class="profileModal">
            {pancard ? (
              <>
                <a>
                  <div className="sampleUpload mb-4 justify-content-center">
                    <div className="sampleUpload-file">
                      <div className="imgWrap">
                        <img src={pancard} alt="#" />
                      </div>
                    </div>
                  </div>
                </a>
                <div className="text-center">
                  <button
                    className="button button-primary"
                    onClick={handleUpload}
                  >
                    UPLOAD PAN
                  </button>
                </div>

                <div class="profileModal-note mt-2 pb-0">
                  <h2>Please ensure that:</h2>
                  <ol>
                    <li>The complete PAN Card is visible.</li>
                    <li>Do not upload tilted or blurry image.</li>
                  </ol>
                </div>
              </>
            ) : (
              <>
                <div class="profileModal-opt">
                  <a className="w-auto" onClick={handleFileUploadClick}>
                    {" "}
                    <b class="icon-upload"></b> Upload File
                  </a>
                </div>
                {/* { error?.type === "PanCardSizeError" || error?.type === 'PanCardError'?
                  <div className="label-error">{error?.message}</div>
                  :
                    null
                } */}
                <div class="profileModal-note pt-2 pb-2">
                  <h2>Please ensure that:</h2>
                  <ol>
                    <li>The complete PAN Card is visible.</li>
                    <li>Do not upload tilted or blurry image.</li>
                  </ol>
                </div>
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  ref={PancardRef}
                  // required={true}
                  onChange={(e) => handleFileChange(e)}
                />
              </>
            )}
          </div>
        </ProfileUploadModal>
        <ServiceCongrats />
        <UploadSampleWorks
          show={uploadSamples || urlError}
          close={handleuploadSamplesClose}
          handleAddUrlModal={handleAddUrlModal}
          samples={samples}
          setSamples={setSamples}
          UploadMedia={UploadMedia}
          setServicesCount={setServicesCount}
          servicesCount={servicesCount}
          setSamplesUpload={setSamplesUpload}
          setCurrentService={setCurrentService}
          currentService={currentService}
          setUrlError={setUrlError}
          urlError={urlError}
        />
      </Form>
      <UploadUrlModal
        show={openUrlModal}
        close={handleurlModalClose}
        handleBack={handleGOPreviousModal}
        handleuploadUrl={handleuploadUrl}
        url={url}
        setUrl={setUrl}
      />
      <SampleWork
        removeURL={serviceRemoveURL}
        handleClose={handleCloseSampleWork}
        showData={showSamples}
      />
    </>
  );
};
Services.propTypes = {
  openTab: PropTypes.array,
  token: PropTypes.string,
  decodedId: PropTypes.string,
  setOpenTab: PropTypes.func,
  setActiveTab: PropTypes.func,
  setServicesOffered: PropTypes.func,
  setServices: PropTypes.func,
  setServicesCount: PropTypes.func,
  servicesOffered: PropTypes.array,
  services: PropTypes.objectOf(PropTypes.string),
  // servicesCount: PropTypes.arrayOf([PropTypes.object]).isRequired,
  servicesCount: PropTypes.arrayOf(PropTypes.shape([PropTypes.object])),
  handleGoback: PropTypes.func,
  imageDisplayModal: PropTypes.bool,
  setImageDisplayModal: PropTypes.func,
  currentService: PropTypes.object,
  setCurrentService: PropTypes.func,
  samplesUpload: PropTypes.bool,
  setSamplesUpload: PropTypes.func,
  appendURL: PropTypes.func,
  DeleteMedia: PropTypes.func,
  DeletePancard: PropTypes.func,
  refetch: PropTypes.func,
};

Services.defaultProps = {
  openTab: "",
  token: "",
  decodedId: "",
  setOpenTab: () => null,
  setActiveTab: () => null,
  setServicesOffered: () => null,
  setServices: () => null,
  setServicesCount: () => null,
  servicesOffered: [],
  services: {},
  servicesCount: [{}],
  handleGoback: () => null,
  imageDisplayModal: false,
  setImageDisplayModal: () => null,
  currentService: {},
  setCurrentService: () => null,
  samplesUpload: false,
  setSamplesUpload: () => null,
  appendURL: () => null,
  DeleteMedia: () => null,
  DeletePancard: () => null,
  refetch: () => null,
};

export default Services;
